import { render, staticRenderFns } from "./AddBonusModal.vue?vue&type=template&id=2a0089ac&scoped=true"
import script from "./AddBonusModal.vue?vue&type=script&lang=js"
export * from "./AddBonusModal.vue?vue&type=script&lang=js"
import style0 from "./AddBonusModal.vue?vue&type=style&index=0&id=2a0089ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0089ac",
  null
  
)

export default component.exports